import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaBars, FaTimes } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import '../HomePage.css';
import logo from '../images/dc_logo.png';
import dp from '../images/profile_icon.png';
import { useAuth } from './../AuthContext';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const navigate = useNavigate();
  const { isLogged, userData } = useAuth();

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const headerStyle = {
    gap: `${Math.min(150, scrollY)}px`,
    marginTop: `${Math.min(15, scrollY / 5)}px`,
    opacity: `${1 - Math.min(scrollY / 300, 0.2)}`,
    width: `${100 - Math.min(scrollY / 5, 20)}%`, // Starts at 100% and transitions to 80%
    borderRadius: `${Math.min(15, scrollY / 10)}px`, // Starts at 0px and transitions to 15px
  };

  const renderNavLinks = () => {
    if (userData?.role === 'mentors') {
      return (
        <>
          <motion.a href="/#/upcoming-meetings" whileHover={{ scale: 1.1 }} className="nav-link">
            Upcoming Meetings
          </motion.a>
          <motion.a
            whileHover={{ scale: 1.1 }}
            className="nav-link"
            onClick={() => navigate('/mentor-tips')}
          >
            <button className="join-button">Mentor Guide</button>
          </motion.a>
        </>
      );
    }

    if (userData?.role === 'experts') {
      return (
        <>
          <motion.a href="/#/upcoming-meetings" whileHover={{ scale: 1.1 }} className="nav-link">
            Upcoming Meetings
          </motion.a>
          <motion.a
            whileHover={{ scale: 1.1 }}
            className="nav-link"
            onClick={() => navigate('/expert-tips')}
          >
            <button className="join-button">Expert Tips</button>
          </motion.a>
        </>
      );
    }

    // Default for users
    return (
      <>
        <motion.a href="/" whileHover={{ scale: 1.1 }} className="nav-link">
          Home
        </motion.a>
        <motion.a href="/#/career-coaches" whileHover={{ scale: 1.1 }} className="nav-link">
          Career Coaches
        </motion.a>
        <motion.a href="/#/professionals" whileHover={{ scale: 1.1 }} className="nav-link">
          Experts
        </motion.a>
        <motion.a
          whileHover={{ scale: 1.1 }}
          className="nav-link"
          onClick={() => navigate('/enroll')}
        >
          <button className="join-button">Join</button>
        </motion.a>
      </>
    );
  };

  return (
    <header className="header" style={headerStyle}>
      <div className="logo-area">
        <img className="logo-image" src={logo} alt="logo" />
        <div className="logo" onClick={() => {navigate('/')}}>
          {userData?.role === 'mentors'
            ? 'Career Coach Portal'
            : userData?.role === 'experts'
            ? 'Professional Portal'
            : 'The Ideal Pursuits'}
        </div>
      </div>
      <nav className={`nav ${menuOpen ? 'active' : ''}`}>
        {renderNavLinks()}
        {isLogged ? (
          <motion.a href="/#/profile" whileHover={{ scale: 1.1 }} className="nav-link">
            <div className="logo-area">
              <img className="logo-image" src={dp} alt="Profile" />
            </div>
          </motion.a>
        ) : (
          <motion.a href="/#/login" whileHover={{ scale: 1.1 }} className="nav-link">
            <button className="login-button">Login</button>
          </motion.a>
        )}
      </nav>
      <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? <FaTimes /> : <FaBars />}
      </div>
    </header>
  );
};

export default Header;
